import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
/*
 * Tansad_Dclr
 * !== TANSAD 신고 기능 서비스 ==!
 */

export const BASE = {
    path: `${comnEnvs.base}/lpco/tansad`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cscl/tansad-mngt-app`,
    apiRprt: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprt/lpco`,
    nodes: [
        { path: "/", label: "L_CLR" },
        { path: "/dclr/", label: "L_DCLR" },
        { path: "/dclr/tansad", label: "L_TANSAD" },
    ],
};

export const URLS = {
    osci0202001q: `${BASE.path}/osci0202001q`,
    osci0202002q: `${BASE.path}/osci0202002q`,
    osci0202003q: `${BASE.path}/osci0202003q`,
};

export const APIS = {
    // get The List of Tansad_Dclr !== TANSAD 신고 목록 조회 ==!
    getTansadDclrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get the Tansad_Dclr !== TANSAD 신고 조회 ==!
    getTansadDclrGnrl: (cstmOfceCd: any, tansadYy: any, tansadSrno: any) => {
        return api.get(`${BASE.api}/${cstmOfceCd}/${tansadYy}/${tansadSrno}`);
    },
    // get The List of Tansad_Dclr Item!== TANSAD 신고 ITEM 목록 조회 ==!
    getTansadDclrItmLst: (cstmOfceCd: any, tansadYy: any, tansadSrno: any) => {
        return api.get(`${BASE.api}/${cstmOfceCd}/${tansadYy}/${tansadSrno}/itm`);
    },
    // get The List of Tansad_Dclr Item!== TANSAD 신고 ITEM 목록 조회 ==!
    getTansadDclrItm: (cstmOfceCd: any, tansadYy: any, tansadSrno: any, itmNo: any) => {
        return api.get(`${BASE.api}/${cstmOfceCd}/${tansadYy}/${tansadSrno}/itm/${itmNo}`);
    },
    // get The List of Tansad_Dclr Item!== TANSAD 신고 ITEM 목록 조회 ==!
    getTansadDclrItmMdl: (cstmOfceCd: any, tansadYy: any, tansadSrno: any, itmNo: any, mdlNo: any) => {
        return api.get(`${BASE.api}/${cstmOfceCd}/${tansadYy}/${tansadSrno}/itm/${itmNo}/mdl/${mdlNo}`);
    },
    // get The List of Tansad_Dclr Item!== TANSAD 신고 첨부파일 목록 조회 ==!
    getTansadDclrAtchDocDtl: (cstmOfceCd: any, tansadYy: any, tansadSrno: any, tansadDocTpCd: any, docSrno: any) => {
        return api.get(
            `${BASE.api}/${cstmOfceCd}/${tansadYy}/${tansadSrno}/tansadDocTpCd/${tansadDocTpCd}/docSrno/${docSrno}`,
        );
    },

    getLpcoRprt: (appId: string) => {
        return api.get(`${BASE.apiRprt}/${appId}`, {
            responseType: "arraybuffer",
        });
    },
};

// Tansad_Dclr Search Form Schema !== TANSAD 신고 검색 폼 스키마 ==!
export const SF_TANSAD_DCLR_SRCH: TFormSchema = {
    id: "form_TansadDclrSrch",
    schema: {
        reffDtmRange: {
            type: "daterange",
            label: "L_DCLA_DATE",
            start: { name: "reffDtFrom", required: true },
            end: { name: "reffDtTo", required: true },
            required: true,
            rangeButton: 2,
            controlSize: 10,
        },
        referenceNo: {
            label: "L_REFF_NO",
            controlSize: 2,
        },
        reffTin: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 9,
            imemode: "number",
        },
        reffYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 2,
            imemode: "number",
        },
        reffSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 7,
            imemode: "number",
        },
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
        },
        cstmOfceCd: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 4,
            letterCase: "upper",
        },
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 2,
            imemode: "number",
        },
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            maxLength: 7,
            imemode: "number",
            // required: true,
        },
        decrModeCd: {
            type: "select",
            all: true,
            label: "L_DCLR_MODE_CD",
            area: "comnCd",
            comnCd: "OSC0042",
            editType: "both",
        } /* 신고서_모드_코드 */,
        dclrPrcssSttsCd: {
            type: "select",
            all: true,
            label: "L_TANSAD_PRCSS_STTS_CD",
            area: "comnCd",
            comnCd: "OSC0018",
            editType: "both",
        } /* 신고서_처리_상황_코드 */,
        csclPrcssCstm: {
            type: "code",
            label: "L_PRCS_CSTM",
            area: "cstmCd",
        } /* 통관_처리_세관 */,
        entryCstmOfceCd: {
            type: "code",
            label: "L_ENTRY_CSTM_OFCE",
            area: "cstmCd",
            popupParams: { dclrYn: "Y" },
            maxLength: 5,
            imemode: "number+upper",
        },
        ucrNo: {
            type: "text",
            label: "L_UCR_NO",
        },
        dstnCntyCd: {
            type: "code",
            label: "L_DSTN_CNTY_CD",
            area: "cntyCd",
        } /** DESTINATION COUNTRY CODE !== 목적지_국가_코드 ==! */,
    },
};

// Tansad_Dclr List Grid !== TANSAD 신고 List Grid ==!
export const SG_TANSAD_DCLR_LST: TGridSchema = {
    id: "grid",
    options: { pagination: "out", height: "auto", exportExcel: true },

    head: [
        { cells: [{ header: "L_TANSAD_NO", width: 150, rowspan: 2 }] },
        { cells: [{ header: "L_DCER_MODE_CD", width: 130 }, { header: "L_CSCL_PLN_CD" }] },
        { cells: [{ header: "L_DCLT_TIN", width: 150 }, { header: "L_IMEX_TIN" }] },
        { cells: [{ header: "L_EXP_CNTY_CD", width: "15%", rowspan: 2 }] },
        { cells: [{ header: "L_GODS_LOCT_REFF_CN", width: "*" }, { header: "L_WRHS_CD" }] },
        { cells: [{ header: "L_TOT_CSTM_VAL", width: "10%", rowspan: 2 }] },
        { cells: [{ header: "L_TANSAD_DT" }, { header: "L_DCLR_PRCSS_STTS_CD", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "tansadNo", rowspan: 2 }],
        },
        {
            cells: [
                { binding: "decrModeCd", area: "comnCd", comnCd: "OSC0042", viewType: "value", type: "code" },
                { binding: "csclPlnCd", area: "comnCd", comnCd: "OSC0023", viewType: "value", type: "code" },
            ],
        },
        {
            cells: [
                { binding: "dcltTin", area: "coCd" },
                { binding: "exImTin", area: "coCd" },
            ],
        },
        {
            cells: [
                { binding: "expCntyCd", area: "cntyCd", type: "select", viewType: "both", align: "left", rowspan: 2 },
            ],
        },
        {
            cells: [
                { binding: "godsLoctReffCn", area: "wrhsCd", type: "select", viewType: "both", align: "left" },
                { binding: "wrhsCd", area: "wrhsCd", type: "select", viewType: "both", align: "left" },
            ],
        },
        {
            cells: [{ binding: "totCstmVal", type: "number", align: "right", rowspan: 2 }],
        },
        {
            cells: [
                { binding: "tansadDt" },
                {
                    binding: "dclrPrcssSttsCd",
                    area: "comnCd",
                    comnCd: "OSC0018",
                    editType: "both",
                    viewType: "both",
                    type: "code",
                    rowspan: 2,
                },
            ],
        },
    ],
};

// Tansad_Dclr Search Form Schema !== TANSAD 신고 검색 폼 스키마 ==!
export const SF_TANSAD_DCLR_DTL: TFormSchema = {
    id: "form_TansadDclrDtl",
    schema: {
        referenceNo: {
            label: "L_REFF_NO",
            controlSize: 2,
        },
        reffTin: {
            type: "text",
            controlSize: 1,
            only: "control",
        },
        reffYy: {
            type: "text",
            controlSize: 1,
            only: "control",
        },
        reffSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
        },
        reffDtm: {
            type: "date",
            label: "L_REFF_DT",
        },
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
        },
        amdDgr: {
            label: "L_AMT_DGR",
            controlSize: 2,
        },
        cstmOfceCd: {
            type: "text",
            label: "L_PRCSS_CSTM_OFCE",
            area: "cstmCd",
        },
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
        },
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
        },
        tansadDt: {
            type: "text",
            label: "L_TANSAD_DT",
        },
        decrModeCd: {
            type: "text",
            label: "L_DCLR_MODE_CD",
            area: "comnCd",
            comnCd: "OSC0042",
            editType: "both",
        },
        csclPrcssCstm: {
            type: "code",
            label: "L_CSCL_PRCSS_CSTM",
            area: "cstmCd",
        },
        godsLoctReffCn: {
            type: "code",
            label: "L_GODS_LOCT_REFF_CN",
            //area: "cstmCd",
            area: "wrhsCd",
            viewType: "both",
        },
        entryCstmOfceCd: {
            type: "code",
            label: "L_ENTRY_CSTM_OFCE_CD",
            area: "cstmCd",
        },
        dclrPrcssSttsCd: {
            type: "select",
            label: "L_TANSAD_PRCSS_STTS_CD",
            area: "comnCd",
            comnCd: "OSC0018",
            editType: "both",
        },
        sltvRsltCd: {
            type: "select",
            label: "L_SLTV_RSLT_CD",
            //area: "seletivity",
            area: "comnCd",
            comnCd: "OSC0033",
            editType: "both",
        },
        suspdYn: {
            type: "text",
            label: "L_SUSPD_YN",
        },
        cncltnRcveYn: {
            type: "text",
            label: "L_CNCLTN_RCVE_YN",
        },
        dsmsYn: {
            type: "text",
            label: "L_DSMS_YN",
        },
        dsmsCd: {},
        csclPlnCd: {
            type: "select",
            label: "L_CSCL_PLN_CD",
            comnCd: "OSC0023",
            editType: "both",
            area: "comnCd",
        },
        tansadFmTpCd: {
            type: "select",
            label: "L_TANSAD_FM_TP_CD",
            area: "comnCd",
            comnCd: "OSC0028",
            editType: "both",
        },
        totItmNo: {
            type: "number",
            label: "L_TOT_ITM_NO",
        },
        totPckgNo: {
            type: "number",
            label: "L_TOT_PCKG_NO",
        },
        pckgUtCd: {
            type: "code",
            label: "L_PCKG_UT_CD",
            area: "comnCd",
            comnCd: "OSC0080",
        },
        gwght: {
            type: "number",
            label: "L_GWGHT",
        },
        nwght: {
            type: "number",
            label: "L_NWGHT",
        },
        ucrNo: {
            type: "text",
            label: "L_UCR_NO",
        },
        aeoNo: {
            type: "text",
            label: "L_AEO_NO",
        },
        csmCntyCd: {
            type: "code",
            label: "L_CSM_CNTY_CD",
            area: "cntyCd",
        },
        trdeCntyCd: {
            type: "code",
            label: "L_TRDE_CNTY_CD",
            area: "cntyCd",
        },
        expCntyCd: {
            type: "code",
            label: "L_EXP_CNTY_CD",
            area: "cntyCd",
        },
        dstnCntyCd: {
            type: "code",
            label: "L_DSTN_CNTY_CD",
            area: "cntyCd",
        },
        exppnTin: {
            type: "text",
            label: "L_EXPPN_TIN",
        },
        expCoNm: {
            type: "text",
            label: "L_EXP_CO_NM",
        },
        expCoAddr: {
            type: "text",
            label: "L_EXP_CO_ADDR",
            controlSize: 10,
        },
        imppnTin: {
            type: "text",
            label: "L_IMPPN_TIN",
        },
        impCoNm: {
            type: "text",
            label: "L_IMP_CO_NM",
        },
        impCoAddr: {
            type: "text",
            label: "L_IMP_CO_ADDR",
            controlSize: 10,
        },
        dcltTin: {
            type: "text",
            label: "L_DCLT_TIN",
        },
        dclrCoNm: {
            type: "text",
            label: "L_DCLR_CO_NM",
        },
        dclrCoAddr: {
            type: "text",
            label: "L_DCLR_CO_ADDR",
        },
        incoCd: {
            type: "code",
            label: "L_DLVR_TERMS",
            area: "comnCd",
            comnCd: "OSC0027",
        },
        hndvPlcCd: {
            type: "code",
            label: "L_DLVR_PLC_CD",
            area: "cityCd",
        },
        dclrInvcNo: {
            type: "text",
            label: "L_DCLR_INVC_NO",
        },
        invcDt: {
            type: "date",
            label: "L_INVC_DT",
        },
        totInvcAmt: {
            label: "L_TOT_INVC_AMT",
        },
        currCd: {
            type: "code",
            label: "L_CURR_CD",
            area: "currCd",
        },
        payMeanDstcCd: {
            type: "code",
            label: "L_PAY_MEAN_DSTC_CD",
            area: "comnCd",
            comnCd: "OSC0040",
        },
        bnkCd: {
            type: "code",
            label: "L_BNK_CD",
            area: "bnkCd",
        },
        payAcctNo: {
            type: "text",
            label: "L_PAY_ACCT_NO",
        },
        secuDstcCd: {
            type: "code",
            label: "L_SECU_DSTC_CD",
            area: "comnCd",
            comnCd: "OSC0037",
        },
        secuAcctNo: {
            type: "text",
            label: "L_SECU_ACCT_NO",
        },
        natTrpt: {
            label: "L_NATURE_TRANSACTION",
            controlSize: 2,
        },
        trscNatCd: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0029",
        },
        trscNatuBaseCd: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0030",
        },
        xtrnFrghLb: {
            label: "L_FRGH_AMT",
            controlSize: 2,
        },
        xtrnFrghCurrCd: {
            type: "select",
            label: "XTRN_FRGH_CURR_CD",
            area: "currCd",
            only: "control",
            editType: "value",
            defaultValue: "USD",
            controlSize: 1,
        },

        xtrnFrghAmt: {
            type: "number",
            label: "XTRN_FRGH_AMT",
            only: "control",
            controlSize: 3,
        },
        insrLb: {
            label: "L_INSR_AMT",
            controlSize: 2,
        },
        insrCurrCd: {
            type: "select",
            label: "L_INSR_CURR_CD",
            area: "currCd",
            editType: "value",
            defaultValue: "USD",
            only: "control",
            controlSize: 1,
        },

        insrAmt: { type: "number", label: "INSR_AMT", only: "control", controlSize: 3 },
        othrCostLb: {
            label: "L_OTHR_COST_AMT",
            controlSize: 2,
        },
        othrCostCurrCd: {
            type: "select",
            label: "OTHR_COST_CURR_CD",
            area: "currCd",
            editType: "value",
            defaultValue: "USD",
            only: "control",
            controlSize: 1,
        },

        othrCost: { type: "number", label: "OTHR_COST", only: "control", controlSize: 3 },
        ddctLb: {
            label: "L_DDCT_AMT",
            controlSize: 2,
        },
        ddctCurrCd: {
            type: "select",
            label: "DDCT_CURR_CD",
            area: "currCd",
            only: "control",
            controlSize: 1,
            editType: "value",
            defaultValue: "USD",
        },

        ddctAmt: { type: "number", label: "DDCT_AMT", only: "control", controlSize: 3 },

        totStstclVal: { type: "number", label: "L_TOT_STSTC_VAL" },
        totCstmVal: { type: "number", label: "L_TOT_CSTM_VAL" },
        prevValtnPayYn: {
            type: "select",
            label: "L_PRE_VALTN_PAY_YN",
            select: false,
            options: [{ label: "Y", value: "Y" }],
        },

        csclTrptModeCd: {
            type: "code",
            label: "L_CSCL_TRPT_MODE_CD",
            area: "comnCd",
            comnCd: "OSC0026",
        },

        trptMeanReffCn: {
            type: "text",
            label: "L_TRPT_MEAN_REFF_CN",
        },

        trptNatCd: {
            type: "code",
            label: "L_TRPT_NAT_CD",
            area: "cntyCd",
        },

        arvlDt: {
            type: "date",
            label: "L_ARVL_DT",
        },

        crn: {
            type: "text",
            label: "L_CRN",
        },

        blNo: {
            type: "text",
            label: "L_BL_NO",
        },

        vsslNm: {
            type: "text",
            label: "L_VSSL_NM",
        },

        blPrtlYn: {
            type: "select",
            label: "L_BL_PRTL_YN",
            select: false,
            defaultValue: "N",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
        },

        shpmRegnCd: {
            type: "code",
            label: "L_SHPM_REGN_CD",
            area: "portAirptCd",
        },

        shpmDt: {
            type: "text",
            label: "L_SHPM_DT",
        },

        dscgPlcCd: {
            type: "code",
            label: "L_DSCG_PLC_CD",
            area: "portAirptCd",
        },

        dscgDt: {
            type: "date",
            label: "L_DSCG_DT",
        },

        totCntrCnt: {
            type: "text",
            label: "L_TOT_CNTR_CNT",
        },

        wrhsCd: {
            type: "code",
            label: "L_WRHS_CD",
            area: "wrhsCd",
        },

        prevWrhsCd: {
            type: "code",
            label: "L_PRE_WRHS_CD",
            area: "wrhsCd",
        },

        wrhsPridDays: {
            type: "number",
            label: "L_WAREHOUSE_PERIOD",
        },

        cagRcptDclaReffNo: {
            type: "text",
            label: "L_CAG_RCPT_DCLA_REFF_NO",
        },
        invcExrt: {
            type: "text",
            label: "L_EXRT",
        },
        blreRlse: {
            label: "L_EXRT",
            only: "control",
        },
        stfngRprtNo: {
            type: "text",
            label: "L_STFNG_RPRT_NO",
        },
        cntrNo: {
            type: "text",
            label: "L_CNTR_NO",
        },
        fileCpltYn: {
            type: "text",
            label: "Attached File Completion Y/N",
        },
        vrfnOfcrId: {
            type: "text",
        },
    },
};

// Tansad_Dclr List Grid !== TANSAD 신고 List Grid ==!
export const SG_TANSAD_DCLR_VIA_CNTY_LST: TGridSchema = {
    id: "grid",
    options: {
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_VIA_CNTY_SRNO", width: "10%" }] },
        { cells: [{ header: "L_VIA_CNTY_CD", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "viaCntySrno" }],
        },
        {
            cells: [{ binding: "viaCntyCd", area: "cntyCd", editType: "both" }],
        },
    ],
};

// Tansad_Dclr List Grid !== TANSAD 신고 List Grid ==!
export const SG_TANSAD_DCLR_ITM_LST: TGridSchema = {
    id: "grid",
    options: {},
    head: [
        { cells: [{ header: "L_ITM_NO", binding: "itmNo", width: "*" }] },
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: "*" }] },
        { cells: [{ header: "L_ORIG_CNTY_CD", binding: "origCntyCd", width: "*" }] },
        {
            colspan: 2,
            cells: [{ header: "L_CPC", binding: "cpcCd", width: "*", colspan: 2 }],
        },
        { cells: [{ header: "L_BRND_NM", binding: "brndNm", width: "*" }] },
        { cells: [{ header: "L_ITM_STSTCL_VAL", binding: "itmStstclVal", width: "*" }] },
        { cells: [{ header: "L_ITM_CSTM_VAL", binding: "itmCstmVal", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "itmNo" }],
        },
        {
            cells: [{ binding: "hsCd", area: "hsCd", viewType: "value", type: "code" }],
        },
        {
            cells: [{ binding: "origCntyCd", area: "cntyCd", viewType: "value", type: "code" }],
        },
        {
            colspan: 2,
            cells: [
                { binding: "epcCd" },
                { binding: "apcCd" },
            ],
        },
        {
            cells: [{ binding: "brndNm" }],
        },
        {
            cells: [{ binding: "itmStstclVal" }],
        },
        {
            cells: [{ binding: "itmCstmVal" }],
        },
    ],
};

// Tansad_Dclr Search Form Schema !== TANSAD 신고 검색 폼 스키마 ==!
export const SF_TANSAD_DCLR_ITM: TFormSchema = {
    id: "form_tansadDlcrItm",
    schema: {
        itmNo: {
            type: "number",
            label: "L_ITM_NO",
        },
        hsCd: {
            type: "text",
            label: "L_HS_CD",
        },
        hs4Cd: {
            type: "text",
            label: "L_HS4_CD",
        },
        hs8Cd: {
            type: "text",
            label: "L_HS8_CD",
            area: "hsCd",
        },
        godsHsDesc1: {
            type: "text",
            label: "L_GODS_HS_DESC_1",
        },
        godsHsDesc2: {
            type: "text",
            label: "L_GODS_HS_DESC_2",
        },
        pckgParkMarkNo1Lb: {
            label: "L_PCKG_PART_MARK_NO_1",
        },
        itmUseYn: {
            type: "select",
            //label: "L_PCKG_PART_MARK_NO_1",
            only: "control",
            select: false,
            options: [
                { label: "New", value: "N" },
                { label: "Used", value: "U" },
            ],
        },
        pckgPartMarkNo1: {
            type: "text",
            label: "L_PCKG_PART_MARK_NO_1",
        },
        pckgPartMarkNo2: {
            type: "text",
            label: "L_PCKG_PART_MARK_NO_2",
        },
        tansadSbmtPupsCd: {
            type: "text",
            label: "L_TANSAD_SBMT_PUPS_CD",
        },
        origCntyCd: {
            type: "code",
            label: "L_ORIG_CNTY_CD",
            area: "cntyCd",
        },
        cpc: {
            label: "L_CPC",
        },
        epcCd: {
            type: "text",
            label: "L_EPC",
        },
        epcDesc: {
            type: "text",
            label: "L_EPC",
            disabled: false,
        },
        apcCd: {
            type: "text",
            label: "L_APC",
        },
        apcDesc: {
            type: "text",
            label: "L_APC",
            disabled: false,
        },
        pfrnReffCn: {
            type: "text",
            label: "L_PFRN_REFF_CN",
        },
        valtnMetdCd: {
            type: "code",
            label: "L_VALTN_METD_CD",
            area: "comnCd",
            comnCd: "OSC0034",
        },
        brndNm: {
            type: "text",
            label: "L_BRND_NM",
        },
        preTansadNo: {
            label: "L_PRE_TANSAD_NO",
        },

        prevCstmOfceCd: {
            type: "text",
            label: "L_PRE_CSTM_OFCE_CD",
        },

        prevTansadYy: {
            type: "text",
            label: "L_PRE_TANSAD_YY",
        },

        prevTansadSrno: {
            type: "text",
            label: "LPRE_TANSAD_SRNO",
        },

        prevTansadItmNo: {
            type: "text",
            label: "L_PRE_TANSAD_ITM_NO",
        },

        prevTansadDtm: {
            type: "date",
            label: "L_PRE_TANSAD_DTM",
        },
        ltrReffLb: {
            label: "L_LTR_REFF_NO",
        },
        exmpnKndCd: {
            type: "select",
            label: "L_EXMPN_KND_CD",
            area: "comnCd",
            editType: "both",
            comnCd: "OSC0051",
            select: true,
        },

        ltrReffNo: {
            type: "text",
            label: "L_LTR_REFF_NO",
        },
        vatExmpnAplyNo: {
            type: "text",
            label: "L_VAT_DFMT_APLY_NO",
        },

        itmQty: {
            type: "text",
            label: "L_ITM_QTY",
        },

        itmQtyUtCd: {
            type: "code",
            label: "L_ITM_QTY_UT_CD",
            area: "comnCd",
            comnCd: "OSC0031",
        },

        dtyBaseVal: {
            type: "text",
            label: "L_DTY_BASE_VAL",
        },

        spfcCd: {
            type: "text",
            label: "L_SPFC_CD",
        },

        drwbSpfcCd: {
            type: "text",
            label: "L_DRWB_SPFC_CD",
        },

        gwght: {
            type: "number",
            label: "L_GWGHT",
        },

        nwght: {
            type: "number",
            label: "L_NWGHT",
        },

        itmCstmVal: {
            type: "number",
            label: "L_ITM_CSTM_VAL",
        },

        itmStstclVal: {
            type: "number",
            label: "L_ITM_STSTCL_VAL",
        },

        vehicleYn: {
            type: "select",
            label: "L_VEHICLE_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
        },

        itmXtrnFrghTzsAmt: {
            type: "number",
            label: "L_FRGH_NCY",
        },
        itmXtrnFrghAmt: {
            type: "number",
            label: "L_XTRN_FRGH_AMT",
        },
        itmInsrAmt: {
            type: "number",
            label: "L_INSR_AMT",
        },
        itmInsrTzsAmt: {
            type: "number",
            label: "L_INSR_TZS",
        },
    },
};

// Tansad_Dclr Search Form Schema !== TANSAD 신고 검색 폼 스키마 ==!
export const SF_TANSAD_DCLR_ITM_VHCL: TFormSchema = {
    id: "form_tansadDlcrItmVhcl",
    schema: {
        itmNo: {
            type: "number",
            label: "L_ITM_NO",
        },
        chssNo: {
            type: "text",
            label: "L_CHSS_NO",
        },
        vhclMnfcYy: {
            type: "text",
            label: "L_VHCL_MNFC_YY",
        },
        vhclMkerCd: {
            type: "code",
            label: "L_VHCL_MKER_CD",
            area: "vhclMkerCd",
        },
        vhclMdlCd: {
            type: "code",
            label: "L_VHCL_MDL_CD",
            area: "vhclMdlCd",
        },
        vhclMdlNoCd: {
            type: "code",
            label: "L_VHCL_MDL_NO_CD",
            area: "vhclMdlNoCd",
        },
        vhclPrplTpCd: {
            type: "code",
            label: "L_VHCL_PRPL_TP_CD",
            area: "vhclPrplTpCd",
        },
        vhclBodyTpCd: {
            type: "code",
            label: "L_VHCL_BODY_TP_CD",
            area: "vhclBodyCd",
        },
        vhclTrmssnTpCd: {
            type: "select",
            label: "L_VHCL_TRMSSN_TP_CD",
            area: "vhclTrmssnTpCd",
            editType: "both",
        },
        vhclCtgrCd: {
            type: "select",
            label: "L_VHCL_CTGR_CD",
            area: "vhclCtgrCd",
            editType: "both",
        },
        tareWght: {
            type: "text",
            label: "L_TARE_WGHT",
        },
        vhclGwght: {
            type: "text",
            label: "L_VHCL_GWGHT",
        },
        engnNo: {
            type: "text",
            label: "L_ENGN_NO",
        },
        seatCapc: {
            type: "text",
            label: "L_SEAT_CAPC",
        },
        vhclPuchDt: {
            type: "text",
            label: "L_VHCL_PUCH_DT",
        },
        vhclClrCd: {
            type: "code",
            label: "L_VHCL_CLR_CD",
            area: "vhclClrCd",
        },
        engnCubcCapc: {
            type: "text",
            label: "L_ENGN_CUBC_CAPC",
        },

        engnKwCapc: {
            type: "text",
            label: "L_ENGN_KW_CAPC",
        },

        engnHpCapc: {
            type: "text",
            label: "L_ENGN_HP_CAPC",
        },

        axleNo: {
            type: "text",
            label: "L_AXLE_NO",
        },

        axleDste: {
            type: "text",
            label: "L_AXLE_DSTE",
        },

        vhclOwrCtgrCd: {
            type: "select",
            label: "L_VHCL_OWR_CTGR_CD",
            area: "vhclHlpnCtgrCd",
            editType: "both",
        },

        vhclUseCd: {
            type: "select",
            label: "L_VHCL_USE_CD",
            area: "vhclUseCd",
            editType: "both",
        },

        flTpCd: {
            type: "select",
            label: "L_FL_TP_CD",
            area: "vhclFlCd",
            editType: "both",
        },

        sarpcoCrteNo: {
            type: "text",
            label: "L_SARPCO_CRTE_NO",
        },

        frgnrRgsrNo: {
            type: "text",
            label: "L_FRGNR_RGSR_NO",
        },

        insrCoNm: {
            type: "text",
            label: "L_INSR_CO_NM",
        },

        insrNo: {
            type: "text",
            label: "L_INSR_NO",
        },

        vhclInsrTpCd: {
            type: "select",
            label: "L_VHCL_INSR_TP_CD",
            area: "vhclInsrTpCd",
            editType: "both",
        },

        vhclImpCntyCd: {
            type: "code",
            label: "L_CNTY_CD",
            area: "vhclImpCntyCd",
        },

        insrStrtDt: {
            type: "date",
            label: "L_INSR_STRT_DT",
        },

        insrXpirDt: {
            type: "date",
            label: "L_INSR_XPIR_DT",
        },
        spfcVhclYn: {
            type: "select",
            label: "L_SPFC_VHCL_YN",
            select: false,
            defaultValue: "Y",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
        },

        spfcVhclCmntCn: {
            type: "text",
            label: "L_SPFC_VHCL_CMNT_CN",
        },
        vhclTp: {
            type: "text",
            label: "L_VHCL_TP",
        },
    },
};

// Tansad_Dclr List Grid !== TANSAD 신고 List Grid ==!
export const SG_TANSAD_DCLR_ITM_MDL_LST: TGridSchema = {
    id: "grid",
    options: { pagination: false },
    head: [
        { cells: [{ header: "L_ITM_NO", binding: "itmNo", width: "*" }] },
        { cells: [{ header: "L_MDL_NO", binding: "mdlNo", width: "*" }] },
        { cells: [{ header: "L_MDL_SPEC_CN", binding: "mdlSpecCn", width: "*" }] },
        { cells: [{ header: "L_CPNT_CN", binding: "cpntCn", width: "*" }] },
        { cells: [{ header: "L_ITM_QTY", binding: "itmQty", width: "*" }] },
        { cells: [{ header: "L_UT_VAL", binding: "utVal", width: "*" }] },
        { cells: [{ header: "L_ITM_INVC_AMT", binding: "itmInvcAmt", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "itmNo" }],
        },
        {
            cells: [{ binding: "mdlNo" }],
        },
        {
            cells: [{ binding: "mdlSpecCn" }],
        },
        {
            cells: [{ binding: "cpntCn" }],
        },
        {
            cells: [{ binding: "itmQty" }],
        },
        {
            cells: [{ binding: "utVal" }],
        },
        {
            cells: [{ binding: "itmInvcAmt" }],
        },
    ],
};

// Tansad_Dclr Search Form Schema !== TANSAD 신고 검색 폼 스키마 ==!
export const SF_TANSAD_DCLR_ITM_MDL: TFormSchema = {
    id: "form_tansadDlcrItmDtl",
    schema: {
        itmNo: {
            type: "number",
            label: "L_ITM_NO",
        },
        mdlNo: {
            type: "number",
            label: "L_MDL_NO",
        },
        mdlSpecCn: {
            type: "text",
            label: "L_MDL_SPEC_CN",
        },
        cpntCn: {
            type: "text",
            label: "L_CPNT_CN",
        },
        itmQty: {
            type: "text",
            label: "L_ITM_QTY",
        },
        itmQtyUtCd: {
            type: "code",
            label: "L_ITM_QTY_CD",
            area: "comnCd",
            comnCd: "OSC0031",
        },
        utVal: {
            type: "text",
            label: "L_UT_VAL",
        },
        itmInvcAmt: {
            type: "text",
            label: "L_ITM_INVC_AMT",
        },
        imeiCn1: {
            type: "text",
            label: "L_IMEI_CN_1",
        },
        imeiCn2: {
            type: "text",
            label: "L_IMEI_CN_2",
        },
        imeiCn3: {
            type: "text",
            label: "L_IMEI_CN_3",
        },
        imeiCn4: {
            type: "text",
            label: "L_IMEI_CN_4",
        },
        stndCmdtCd: {
            type: "text",
            label: "L_STND_CMDT_CD",
        },
        prevTansadMdlNo: {
            type: "text",
            label: "L_PRE_TANSAD_MDL_NO",
        },
    },
};

// Tansad_Dclr List Grid !== TANSAD 신고 List Grid ==!
export const SG_TANSAD_DCLR_ATCH_LST: TGridSchema = {
    id: "grid",
    options: {},
    head: [
        { cells: [{ header: "L_TANSAD_DOC_TP_CD", binding: "tansadDocTpCd", width: "*" }] },
        { cells: [{ header: "L_DOC_SRNO", binding: "docSrno", width: "5%" }] },
        { cells: [{ header: "L_TANSAD_DGR", width: "5%" }] },
        { cells: [{ header: "L_TASAND_REFF_ITM_NO", binding: "tansadReffItmNo", width: "5%" }] },
        { cells: [{ header: "L_ISS_ORG_NM", width: "8%" }] },
        { cells: [{ header: "L_ISS_DT", width: "8%" }] },
        // { cells: [{ header: "L_RGSR_TP", width: "7%" }] },
        { cells: [{ header: "L_RGSR_DT", binding: "frstRgsrDtm", width: "12%" }] },
        { cells: [{ header: "L_ATCD_FILE", binding: "fileNm", width: "15%" }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "tansadDocTpCd",
                    area: "comnCd",
                    comnCd: "OSC0025",
                    viewType: "both",
                    type: "code",
                    align: "left",
                },
            ],
        },
        {
            cells: [{ binding: "docSrno" }],
        },
        {
            cells: [{ binding: "tansadDgr" }],
        },

        {
            cells: [{ binding: "tansadReffItmNo" }],
        },
        {
            cells: [{ binding: "issOrgNm" }],
        },
        {
            cells: [{ binding: "issDt", type: "date" }],
        },
        // {
        //     cells: [
        //         {
        //             binding: "aprvRegstTpCd",
        //             type: "select",
        //             options: [
        //                 { label: "CFA", value: "C" },
        //                 { label: "OFFICER", value: "V" },
        //             ],
        //             viewType: "both",
        //         },
        //     ],
        // },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
        {
            cells: [{ binding: "bsopId", type: "file", align: "center" }],
        },
    ],
};

// Tansad_Dclr Search Form Schema !== TANSAD 신고 검색 폼 스키마 ==!
export const SF_TANSAD_DCLR_ATCH: TFormSchema = {
    id: "form_tansadDlcrAtchDtl",
    schema: {
        docSrno: {
            type: "text",
            label: "L_DOC_SRNO",
        },
        docNm: {
            type: "text",
            label: "L_DOC_NM",
        },
        docDesc: {
            type: "text",
            label: "L_DOC_DESC",
        },
        tansadDocTpLb: {
            label: "L_DOC_TP_LB",
        },
        tansadDocTpCd: {
            type: "text",
            label: "L_TANSAD_DOC_TP_CD",
            area: "comnCd",
            comnCd: "OSC0025",
            viewType: "both",
        },
        tansadDocTpDesc: {
            type: "text",
            label: "L_TANSAD_DOC_TP_DESC",
        },
        tansadReffItmNo: {
            type: "text",
            label: "L_TASAND_REFF_ITM_NO",
        },
        bsopId: {
            type: "file",
            label: "L_FILE_NM",
        },
        issOrgNm: {
            type: "text",
            label: "L_ISS_ORG_NM",
        },
        issDt: {
            type: "date",
            label: "L_ISS_DT",
        },
        frstRgsrDtm: {
            type: "datetime",
            label: "L_RGSR_DT",
        },
    },
};

// Tansad_Dclr List Grid !== TANSAD 신고 List Grid ==!
export const SG_TANSAD_DCLR_MDL_VLTN_LST: TGridSchema = {
    id: "grid",
    options: {},
    head: [
        { cells: [{ header: "L_ITM_NO", width: "5%" }] },
        { cells: [{ header: "L_MDL_NO", width: "5%" }] },
        { cells: [{ header: "L_STND_CMDT_CD", width: "15%" }] },
        { cells: [{ header: "L_MDL_SPEC_CN", width: "20%" }] },
        { cells: [{ header: "L_CPNT_CN", width: "20%" }] },
        {
            colspan: 2,
            cells: [{ header: "L_IMEI", colspan: 2, width: "3%" }],
        },
        { cells: [{ header: "L_STAT", width: "5%" }] },
        {
            colspan: 4,
            cells: [
                { header: "L_QTY", colspan: 2, width: "10%" },
                { header: "L_UT_VAL", width: "10%" },
                { header: "L_AMT", width: "10%" },
            ],
        },
    ],
    body: [
        {
            cells: [{ rowspan: 4, binding: "itmNo" }],
        },
        {
            cells: [{ rowspan: 4, binding: "mdlNo" }],
        },
        {
            cells: [{ rowspan: 4, binding: "stndCmdtCd" }],
        },
        {
            cells: [{ rowspan: 4, binding: "mdlSpecCn" }],
        },
        {
            cells: [{ rowspan: 4, binding: "cpntCn" }],
        },
        {
            colspan: 2,
            cells: [
                { binding: "imeiLb1" },
                { binding: "imeiCn1" },
                { binding: "imeiLb2" },
                { binding: "imeiCn2" },
                { binding: "imeiLb3" },
                { binding: "imeiCn3" },
                { binding: "imeiLb4" },
                { binding: "imeiCn4" },
            ],
        },
        {
            cells: [{ binding: "statD" }, { binding: "statA" }, { rowspan: 2, binding: "statC" }],
        },
        {
            colspan: 4,
            cells: [
                { binding: "dcldQty", colspan: 2 },
                { binding: "dcldUtVal" },
                { binding: "dcldAmt" },
                { binding: "assdQty" },
                { binding: "assdQtyUtCd" },
                { binding: "assdUtVal" },
                { binding: "assdAmt" },
                { rowspan: 2, colspan: 4, binding: "mdlAsmtOpinCn", type: "textarea" },
            ],
        },
    ],
};
